import { IDescriptionDetailsList } from "@/shared/interfaces/ReUsedComponentsProps";

import "./DescriptionDetailsList.scss";

export default function DescriptionDetailsList({
    title,
    description,
    span,
    style,
}: IDescriptionDetailsList) {
    return (
        <dl className='ddlist_container' style={style}>
            <dt className='ddlist_title'>{title}</dt>
            <dd className='ddlist_subtitle'>
                {description ? description : "Дані відсутні"}
                {span ? <span className='ddlist_span'>{span}</span> : null}
            </dd>
        </dl>
    );
}
